import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import checkIcon from '../../../../../images/forms-check-white.svg'
import styles from './check-list-item.css'

/**
 * List item component with check icon
 */
const CheckListItem = ({ children }) => (
  <div className={styles.checkListItem}>
    <div className={styles.checkListIconWrapper}>
      <ReactSVG
        src={checkIcon}
        beforeInjection={(svg) => {
          svg.setAttribute('class', styles.checkListIcon)
        }}
      />
    </div>
    <span className={styles.checkListText}>{children}</span>
  </div>
)

CheckListItem.propTypes = {
  children: PropTypes.node.isRequired
}

export default CheckListItem
